module.exports = __webpack_public_path__ + "img/twitter_icon.5e50007c.png";